import React from "react";
import {
    DialogActions,
    Button,
    CircularProgress
} from "@mui/material";
import { PersonAdd as PersonAddIcon } from "@mui/icons-material";

interface DialogActionButtonsProps {
    onCancel: () => void;
    onCreate: () => void;
    isCreating: boolean;
    isCreateDisabled: boolean;
}

export const DialogActionButtons: React.FC<DialogActionButtonsProps> = ({
    onCancel,
    onCreate,
    isCreating,
    isCreateDisabled
}) => {
    return (
        <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={onCancel} disabled={isCreating}>
                Cancel
            </Button>
            <Button
                variant="contained"
                onClick={onCreate}
                disabled={isCreateDisabled || isCreating}
                startIcon={isCreating ? <CircularProgress size={16} /> : <PersonAddIcon />}
                sx={{
                    backgroundColor: '#162346',
                    '&:hover': { backgroundColor: '#1a2a52' },
                    minWidth: 140
                }}
            >
                {isCreating ? 'Creating...' : 'Create Profile'}
            </Button>
        </DialogActions>
    );
};
